import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormlyFieldAnyComponent } from '@app/shared/components/formly-components/formly-field-any/formly-field-any.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { SubSink } from 'subsink';
import { LocaleNumberPipe } from '@app/pipes/locale-number.pipe';

@Component({
  selector: 'app-formly-field-number',
  templateUrl: './formly-field-number.component.html',
  styleUrls: ['./formly-field-number.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    FormlyModule,
    TranslateModule,
    ReactiveFormsModule,
    LocaleNumberPipe,
  ],
})
export class FormlyFieldNumberComponent extends FormlyFieldAnyComponent implements OnInit, OnDestroy {
  private subsink = new SubSink();

    constructor(private changeDetectorRef: ChangeDetectorRef) {
    super();
  }  

  ngOnInit() {
    // Subscribe to formControl value changes to update localValue
    this.subsink.sink = this.formControl.valueChanges.subscribe(value => {
      this.updateLocalValue(value);
    });
    
    // Initialize with current value
    this.updateLocalValue(this.formControl.value);
  }

  ngOnDestroy(): void {
    this.subsink.unsubscribe();
  }

  private updateLocalValue(modelValue: any): void {
    if(typeof this.formControl.value === 'string') {
      const parsedValue = parseFloat(this.formControl.value);
      if(!isNaN(parsedValue)) {
        this.formControl.setValue(parsedValue, {emitEvent: false});
      }
    }
  }

  public change(event: any): void {
    const value = parseFloat(event.target?.value || event.detail?.value);
    this.formControl.setValue(isNaN(value) ? null : value);
    // Trigger onChange callbacks if defined
    this.onChange(value);
    this.changeDetectorRef.markForCheck();
  }
}
